import React, { Component } from 'react'
import { Link } from "react-router-dom";


class Navbar extends Component {
  constructor() {
    super();
    this.state = {
      isActive: false
    };
    this.logout = this.logout.bind(this)
  }

  logout(event) {
    event.preventDefault();
    sessionStorage.clear();
    window.location.href = "/login";
  }

  render() {
    const loginMode = this.props.loginMode;
    //console.log('loginMode:', loginMode);
    return (
      <section>
        <hr className="hr-class"></hr>  {/* spacer ? */}

        <nav className="navbar is-link is-fixed-top is-size-6">
          <div className="navbar-brand">
            <a
              onClick={() => {
                //document.body.innerHTML = "";
                this.setState({ isActive: !this.state.isActive })
              }}
              role="button"
              className={`navbar-burger ${this.state.isActive ? "is-active" : ""}`}
            >
              <span ></span>
              <span ></span>
              <span ></span>
            </a>
          </div>

          <div className={`navbar-menu ${this.state.isActive ? "is-active" : ""}`} >
            <div className="navbar-start">
              <a className="navbar-item" href="/">
                <span className="icon is-hidden-mobile"> 
                  <i className="fas fa-home"></i>
                </span>
                <span>Home</span>
              </a>

              {(loginMode === "teacher") &&
                <React.Fragment>
                  { (sessionStorage.getItem("firstLanguage") == "simplified-Chinese") && <a className="navbar-item" href="/classes">
                    <span className="icon is-hidden-mobile">
                      <i className="fa fa-users" aria-hidden="true"></i>
                    </span>
                    <span>Classes</span>
                  </a> }

                  <a className="navbar-item" href="/textbooks">
                    <span className="icon is-hidden-mobile">
                      <i className="fas fa-newspaper"></i>
                    </span>
                    <span>Textbooks</span>
                  </a>
                </React.Fragment>
              }

              {(loginMode === "not") &&
                <React.Fragment>
                  <a className="navbar-item" href="/login">
                    <span className="icon is-hidden-mobile">
                      <i className="fas fa-sign-in-alt"></i>
                    </span>
                    <span>Login</span>
                  </a>
                </React.Fragment>
              }
              {(loginMode === "student" || loginMode === "teacher") &&
                <React.Fragment>
                  <a className="navbar-item" href="/task" >
                    <span className="icon is-hidden-mobile">
                      <i className="fas fa-check-square"></i>
                    </span>
                    <span>Tasks</span>
                  </a>       

                  <a className="navbar-item" href="/dashboard" >
                    <span className="icon is-hidden-mobile">
                      <i className="fas fa-chart-line"></i>
                    </span>
                    <span>Dashboard</span>
                  </a>                  
                  <a className="navbar-item" onClick={this.logout} href="/logout">
                    <span className="icon is-hidden-mobile">
                      <i className="fas fa-sign-out-alt"></i>
                    </span>
                    <span>Logout</span>
                  </a>
                </React.Fragment>
              }
              <a className="navbar-item" href="/signup">
                <span className="icon is-hidden-mobile">
                  <i className="fas fa-user"></i>
                </span>
                <span>Signup</span>
              </a>      

              <a className="navbar-item" href="/help">
                <span className="icon is-hidden-mobile">
                  <i className="fa-solid fa-circle-info"></i>
                </span>
                <span>Help</span>
              </a>

            </div>
          </div>
        </nav>
      </section>

    );

  }
}

export default Navbar